import axios from './../../config/axios';

function list(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;

    return axios().get("/fleet/vehicles", { params })
}

function create(data) {
    return axios().post("/fleet/vehicles", data);
}

function get(id) {
    return axios().get(`/fleet/vehicles/${id}`);
}

function update(id, data) {
    return axios().put(`/fleet/vehicles/${id}`, data)
}

function remove(id) {
    return axios().delete(`/fleet/vehicles/${id}`);
}

function plateTypes() {
    return axios().get("/fleet/vehicles/plate-types");
}

export default {
    create,
    get,
    list,
    update,
    remove,
    plateTypes
}